import axios from 'axios';

// Configuración de la URL base de la API
// Usar siempre la URL HTTPS para que funcione desde cualquier máquina
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://unionfamiliar.devhacks.ovh';

// Configurar baseURL global para todas las peticiones axios
axios.defaults.baseURL = API_BASE_URL;

// Interceptor para agregar el token a todas las peticiones
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
